export default {"src":"/_next/static/media/razer_laptop_logo.96b96f57.svg","height":720,"width":720};